import { render, staticRenderFns } from "./btnsqr.vue?vue&type=template&id=3b28300c"
import script from "./btnsqr.vue?vue&type=script&lang=js"
export * from "./btnsqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports